export const stringAddStartIfNotStartsWith = (
  start: string,
  stringToModify: string
): string =>
  stringToModify.startsWith(start)
    ? stringToModify
    : `${start}${stringToModify}`;
